/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-no-bind */
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Image, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Field, Formik } from 'formik';
import { toast } from 'react-toastify';
import { BoxForm, BoxInput, ButtonContainer, Container } from './styles';
import { PageTitle } from '../../components/PageTitle';
import { api } from '../../services/api';

export function TestimonialCreate() {
  const [initialValues] = useState({
    name: '',
    text: '',
    video_url: '',
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isShowHome, setIsShowHome] = useState(false);
  const [testimonialToUpload, setTestimonialToUpload] = useState();
  const [testimonialPreview, setTestimonialPreview] = useState(null);
  const [productCategories, setProductCategories] = useState(null);
  const [productCategoriesSelected, setProductCategoriesSelected] = useState(
    [],
  );

  const navigate = useNavigate();

  async function createTestimonials(values) {
    setButtonLoading(true);
    try {
      const formData = new FormData();
      const { name, text, video_url } = values;

      if (testimonialToUpload) {
        formData.append('file', testimonialToUpload, testimonialToUpload.name);
      }

      formData.append('name', name);
      formData.append('text', text);
      formData.append('is_show_home', isShowHome);
      if (video_url) {
        formData.append('video_url', video_url);
      }

      formData.append(
        'product_category_ids',
        productCategoriesSelected.join(','),
      );

      await api.post('/testimonials', formData);
      toast.success('Depoimento cadastrado com sucesso');

      setButtonLoading(false);
      navigate(-1);
    } catch (err) {
      console.log(err);
      toast.error('Erro ao cadastrar depoimento');
      setButtonLoading(false);
    }
  }

  function handleTestimonialPhono(event) {
    if (event.target.files) {
      const file = event.target.files[0];
      setTestimonialToUpload(file);

      const reader = new FileReader();

      reader.onload = () => {
        setTestimonialPreview(reader.result);
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

  async function loadProductCategories() {
    try {
      const response = await api.get('/products/categories');
      setProductCategories(response.data);
    } catch (error) {
      toast.error('Erro ao carregar categorias');
    }
  }

  useEffect(() => {
    loadProductCategories();
  }, []);

  return (
    <Container>
      <Breadcrumb style={{ marginBottom: 40 }}>
        <Breadcrumb.Item key="/">
          <NavLink to="/">
            <HomeOutlined />
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="/depoimentos">
          <NavLink to="/depoimentos">Depoimentos</NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Criação</Breadcrumb.Item>
      </Breadcrumb>

      <PageTitle
        title="Cadastro de depoimentos"
        description="Gerenciamento de depoimentos"
      />

      <BoxForm>
        <Formik initialValues={initialValues} onSubmit={createTestimonials}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              {testimonialPreview && (
                <div>
                  <Image width={200} height={200} src={testimonialPreview} />
                </div>
              )}
              <BoxInput style={{ marginTop: 30 }}>
                <label htmlFor="photo">Foto</label>
                <input
                  id="photo"
                  type="file"
                  name="photo"
                  onChange={handleTestimonialPhono}
                />
              </BoxInput>

              <BoxInput>
                <label htmlFor="name">Nome</label>
                <Field id="name" type="text" name="name" placeholder="Nome" />
              </BoxInput>

              <BoxInput>
                <label htmlFor="name">Vídeo URL</label>
                <Field
                  id="video_url"
                  type="text"
                  name="video_url"
                  placeholder="Vídeo URL"
                />
              </BoxInput>

              <BoxInput>
                <label htmlFor="text">Texto</label>
                <Field name="text">
                  {({ field }) => (
                    <div>
                      <textarea {...field} value={field.value || ''} />
                    </div>
                  )}
                </Field>
              </BoxInput>

              <BoxInput>
                <label htmlFor="is_show_home">Mostrar na home</label>
                <Switch
                  defaultChecked
                  checked={isShowHome}
                  onChange={() => setIsShowHome(!isShowHome)}
                />
              </BoxInput>

              <BoxInput>
                <label htmlFor="is_show_home">Categorias</label>
                <Checkbox.Group
                  onChange={(checkedValues) =>
                    setProductCategoriesSelected(checkedValues)
                  }
                >
                  {productCategories &&
                    productCategories.map((categoryItem) => (
                      <Checkbox value={categoryItem.id}>
                        {categoryItem.name}
                      </Checkbox>
                    ))}
                </Checkbox.Group>
              </BoxInput>

              <ButtonContainer>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  loading={buttonLoading}
                >
                  Cadastrar depoimento
                </Button>
              </ButtonContainer>
            </form>
          )}
        </Formik>
      </BoxForm>
    </Container>
  );
}
